(function () {
	const passwordFields = document.querySelectorAll('input[type="password"]');

	if (!passwordFields.length) {
		return;
	}

	const iconClass = [
		'fa-eye-slash',
		'fa-eye',
	];
	passwordFields.forEach((el, i) => {
		const icon = document.createElement('span');
		icon.classList.add('showIcon', 'fa', iconClass[0]);
		icon.setAttribute('id', 'showIcon-' + i);
		el.insertAdjacentElement('afterend', icon);

		icon.addEventListener('click', () => {
			if(el.type === 'text') {
				el.type = 'password';
				icon.classList.add(iconClass[0]);
				icon.classList.remove(iconClass[1]);
			} else {
				el.type = 'text';
				icon.classList.add(iconClass[1]);
				icon.classList.remove(iconClass[0]);
			}
		});
	});

})();
